import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { City } from "../../../types/city.types";

export const LocationPanelItem = ({
  city,
  onSelect,
}: {
  city: City;
  onSelect?: (city: City) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div
      key={city._id}
      className="group flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-5 py-4 transition-all duration-200 hover:shadow-md hover:border-primaryText dark:hover:border-primaryTextDark cursor-pointer"
      onClick={() => onSelect?.(city)}
    >
      <div className="flex flex-col gap-1">
        <span className="text-xs text-gray-500 dark:text-gray-400">
          <span className="font-medium">{t("City ID")}</span>
          {": "}
          {city._id}
        </span>

        <span className="text-sm text-primaryText dark:text-primaryTextDark">
          <span className="font-medium">{t("City")}</span>
          {": "}
          {city.city}, {city.country}
        </span>

        <span className="text-xs text-gray-500 dark:text-gray-400">
          <span className="font-medium">{t("Latitude")}</span>
          {": "}
          {city.lat} | <span className="font-medium">{t("Longitude")}</span>
          {": "}
          {city.lng}
        </span>

        {city.isAvailable !== undefined && (
          <span
            className={`text-xs font-medium ${
              city.isAvailable
                ? "text-green-600 dark:text-green-400"
                : "text-red-600 dark:text-red-400"
            }`}
          >
            {city.isAvailable ? t("Available") : t("Unavailable")}
          </span>
        )}
      </div>

      <ChevronRight className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition-all duration-200 group-hover:translate-x-1" />
    </div>
  );
};
